import React from 'react';
import { FiArrowRight } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { specialties } from '../data/shopData';

const Specialties = () => {
  return (
    <section className="py-24 px-4 bg-zinc-950">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-6 uppercase leading-none">
            Especialidades <span className="text-yellow-500">Profesionales</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Inglés adaptado a tu carrera. Todo gestionado dentro de nuestro campus online.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
          {specialties.map((spec, i) => (
            <div key={i} className="bg-zinc-900 border border-zinc-800 p-6 rounded-3xl group hover:border-yellow-500/50 transition-all cursor-pointer">
              <div className="w-12 h-12 bg-black rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <SafeIcon icon={spec.icon} className={`text-2xl ${spec.color}`} />
              </div>
              <h3 className="text-sm font-black text-white mb-2 uppercase tracking-tight">{spec.title}</h3>
              <p className="text-[10px] text-gray-500 mb-4 line-clamp-2">{spec.desc}</p>
              <a href="https://app.onlineclassesenglish.com" className="text-[10px] font-bold text-yellow-500 flex items-center gap-1 group-hover:gap-2 transition-all uppercase tracking-widest">
                Entrar <FiArrowRight />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Specialties;